import React, { useState } from "react";

import { MembersIcon, SearchIcon } from "../common/Icon";
import { MyTeamsMemeberData } from "../common/Helper";

const AddTeam = () => {
  const [filteredList, setFilteredList] = useState(MyTeamsMemeberData);
  const [showInput, setShowInput] = useState(false);

  const inputChangeHandler = (value) => {
    const Data = MyTeamsMemeberData.filter((obj) => {
      return obj.membertext.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredList(Data);
  };
  return (
    <>
      <div className="bg-white rounded-[20px] overflow-hidden shadow-todays_workflow_box_shadow pb-3 3xl:pb-6">
        <div className="py-2 2xl:py-3 border-b border-[#f2f2f2] px-[15px] flex justify-between items-center">
          <h3 className="font-bold text-bold text-black text-xs md:text-sm 3xl:text-base">
            My Team
          </h3>
          <div className="flex items-center">
            <div
              className={`border hidden rounded-[50px] xl:max-w-[120px] 2xl:max-w-full sm:flex items-center overflow-hidden py-[7px] pe-2 max-w-[200px]" ${
                showInput ? "border-[#929292]" : "border-transparent"
              }`}>
              <input
                onChange={(e) => inputChangeHandler(e.target.value)}
                type="text"
                placeholder="Search here..."
                className={`w-full  focus:outline-none ps-3 font-normal text-[12px] 3xl:text-sm text-black placeholder:text-gray ${
                  showInput ? "block" : "hidden"
                }`}
              />
              <span
                onClick={() => setShowInput(!showInput)}
                className="cursor-pointer">
                <SearchIcon />
              </span>
            </div>
            <button className="flex group items-center ml-2 text-primary hover:text-white font-normal text-[10px] md:text-xs 3xl:text-sm border border-primary rounded-[26px] bg-transparent hover:bg-primary p-2 transition-all duration-300 ease-in-out ">
              <span className="pr-1.5">
                <MembersIcon />
              </span>
              Create team
            </button>
          </div>
        </div>
        <div className="border mt-3 sm:mt-0  rounded-[50px] flex items-center border-[#929292] overflow-hidden py-[7px] px-2 sm:hidden mx-[15px]">
          <span
            onClick={() => setShowInput(!showInput)}
            className="cursor-pointer">
            <SearchIcon />
          </span>
          <input
            onChange={(e) => inputChangeHandler(e.target.value)}
            type="text"
            placeholder="Search here..."
            className="w-full focus:outline-none ps-3 text-[12px] 3xl:text-sm text-black placeholder:text-gray"
          />
        </div>
        <div className="pt-6 px-[15px]  md:h-[calc(100vh-196px)] xl:h-[calc(100vh-187px)] 2xl:h-[calc(100vh-194px)] 3xl:h-[calc(100vh-220px)] md:overflow-y-auto overflow_x_scroll_style">
          {filteredList.map((obj, index) => (
            <div
              key={index}
              className="flex justify-between w-full hover:shadow-workflow_item_card_shadow rounded-md px-2.5 py-[7px] mb-[15px]">
              <span className="flex items-center">
                <img src={obj.memberimg} alt="trading-scerets-img" />
                <p className="font-normal text-black text-xs md:text-sm 3xl:text-base pl-2.5">
                  {obj.membertext}
                </p>
              </span>
              <button className="flex group items-center ml-2.5 text-black hover:text-white font-normal text-[10px] md:text-[11px] 3xl:text-sm border border-transparent  rounded-[4px] bg-light_purple4 hover:bg-primary p-2 transition-all duration-300 ease-in-out ">
                <span className="pr-1.5">{obj.memberbtnicon}</span>
                {obj.memberbtntext}
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AddTeam;
